const ITALY_TIMEZONE = "Europe/Rome";

export const parseApiDate = (value) => {
  if (!value) {
    return null;
  }

  if (value instanceof Date) {
    return value;
  }

  if (typeof value === "number") {
    return new Date(value);
  }

  if (typeof value !== "string") {
    return new Date(value);
  }

  const trimmed = value.trim();
  if (!trimmed) {
    return null;
  }

  // Timestamps without offset are treated as UTC by convention across our API.
  const normalized = /(?:Z|[+-]\d{2}:\d{2})$/i.test(trimmed)
    ? trimmed
    : `${trimmed}Z`;

  return new Date(normalized);
};

export const formatDateTime = (value, fallback = "Data non disponibile") => {
  const parsed = parseApiDate(value);
  if (!parsed || Number.isNaN(parsed.getTime())) {
    return fallback;
  }

  return new Intl.DateTimeFormat("it-IT", {
    timeZone: ITALY_TIMEZONE,
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  }).format(parsed);
};

export const getDateSortValue = (value) => {
  const parsed = parseApiDate(value);
  return parsed && !Number.isNaN(parsed.getTime()) ? parsed.getTime() : 0;
};

